
<mat-toolbar class="custom-toolbar border-bottom bg-white px-3">
  
  <div class="d-flex align-items-center">
    <mat-icon color="primary" class="toolbar-logo-icon me-2">circle</mat-icon>
    <span class="toolbar-title fw-semibold text-dark">{{ msg() }}</span>
  </div>
  
  <span class="title-spacer flex-grow-1"></span>

  <div class="date-picker-wrapper">
    <mat-form-field appearance="outline" class="toolbar-date-field">
      <mat-label>Période de production</mat-label>
      <mat-date-range-input [formGroup]="dateForm">
        <input matStartDate appDateMask placeholder="Du" formControlName="date_debut">
        <input matEndDate appDateMask placeholder="Au" formControlName="date_fin">
      </mat-date-range-input>
      
      <button mat-icon-button matSuffix color="primary" title="Valider" [disabled]="dateForm.invalid" (click)="loadDocument()">
        <mat-icon>check_circle</mat-icon>
      </button>

      @if (dateForm.hasError('date') && dateForm.touched) {
        <mat-hint class="text-danger fw-medium position-absolute end-0">
          La date de fin doit être supérieure à la date de début
        </mat-hint>
      }
    </mat-form-field>
  </div>

</mat-toolbar>


<mat-card appearance="outlined" class="main-table-card border-0 shadow-sm mt-5">
  <mat-tab-group id="tabGroup" #tabGroup (selectedTabChange)="onTabChange($event)" class="mx-5 my-2">
      <mat-tab label="all">
        <ng-template mat-tab-label>Globale ({{ currentTabName=='all'?dataSource.data.length:'' }})</ng-template>
      </mat-tab>
      <mat-tab label="groupe" *ngIf="currentUser.profil.name=='root'||
        currentUser.profil.name=='owner' || currentUser.profil['validation_suivi']
      ">
        <ng-template mat-tab-label>Par groupe ({{ currentTabName=='groupe'?dataSource.data.length:'' }})</ng-template>
      </mat-tab>
      <mat-tab label="site" *ngIf="currentUser.profil.name=='root'||
        currentUser.profil.name=='owner' || currentUser.profil['validation_suivi']
      ">
        <ng-template mat-tab-label>Par bureau ({{ currentTabName=='site'?dataSource.data.length:'' }})</ng-template>
      </mat-tab>
  </mat-tab-group>

  <mat-card-header class="d-flex align-items-center justify-content-end p-3 border-bottom">
      <div class="mx-2 mt-4">
        <app-search-bar-component (searchBarValue)="applyFilter($event)"></app-search-bar-component>
      </div>
  </mat-card-header>

    <mat-card-content class="position-relative p-0 bg-white table-mat-card-content">
      <!--loading-->
      @if (loading()) {
      <div class="loading-table-shade">
        <mat-spinner diameter="70" color="primary"></mat-spinner>
      </div>
      }

      <!---->
      <div >
      @if(currentTabName=='all'){
        <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort class="w-100 custom-premium-table">
          <!--
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> ID </th>
            <td mat-cell *matCellDef="let row"  data-label="ID"> {{row.assurance_id}} </td>
          </ng-container> -->
          <!-- -->
          <ng-container matColumnDef="police">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Police </th>
            <td mat-cell *matCellDef="let row" class="fw-semibold text-dark" data-label="Police"> {{row.police}} </td>
          </ng-container>

          <!-- -->
          <ng-container matColumnDef="vehicule">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Immatriculation </th>
            <td mat-cell *matCellDef="let row"  data-label="Immatriculation"> {{row.immatriculation | uppercase }} </td>
          </ng-container>

          <!-- -->
          <ng-container matColumnDef="compagnie">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Compagnie </th>
            <td mat-cell *matCellDef="let row"  data-label="Compagnie"> {{row.compagnie}} </td>
          </ng-container>
          <!-- -->

          <ng-container matColumnDef="collaborateur">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Intermediaire </th>
            <td mat-cell *matCellDef="let row"  data-label="Intermediaire"> {{row.collaborateur+" / "+row.site}} </td>
          </ng-container>
          <!-- -->

          <ng-container matColumnDef="attestation">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Attestation </th>
            <td mat-cell *matCellDef="let row" class="fw-semibold text-dark" data-label="Attestation"> {{row.attestation}} </td>
          </ng-container>
          <!-- -->

          <ng-container matColumnDef="carte_rose">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Carte rose </th>
            <td mat-cell *matCellDef="let row" class="fw-semibold text-dark" data-label="Carte rose"> {{row.carte_rose}} </td>
          </ng-container>
          <!-- -->

          <ng-container matColumnDef="bureau">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Bureau </th>
            <td mat-cell *matCellDef="let row"  data-label="Zone"> {{row.site}} </td>
          </ng-container>
          <!-- -->

          <ng-container matColumnDef="groupe">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Groupe </th>
            <td mat-cell *matCellDef="let row"  data-label="Zone"> {{row.groupe_name}} </td>
          </ng-container>
          <!-- -->

          <ng-container matColumnDef="editeur">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Effectuer par  </th>
            <td mat-cell *matCellDef="let row"  data-label="Effectuer par"> {{row.editeur}} </td>
          </ng-container>

          <ng-container matColumnDef="created_at">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Effectuer le  </th>
            <td mat-cell *matCellDef="let row"  data-label="Effectuer le"> {{row.created_at | date:'medium'}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">No data matching the filter "{{searchValue()}}"</td>
          </tr>
              </table>
      </div>      
      }@else if(currentTabName=='groupe'){
        <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort class="w-100 custom-premium-table">
          <!--
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> ID </th>
            <td mat-cell *matCellDef="let row"  data-label="ID"> {{row.assurance_id}} </td>
          </ng-container> -->
          <!-- -->

          <ng-container matColumnDef="groupe">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Groupes </th>
            <td mat-cell *matCellDef="let row" class="fw-semibold text-dark" data-label="Zone"> {{row.groupe_name}} </td>
          </ng-container>
          <!-- -->


          <ng-container matColumnDef="production">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Nombre </th>
            <td mat-cell *matCellDef="let row"  data-label="Zone"> {{row.production}} </td>
          </ng-container>
          <!-- -->

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">No data matching the filter "{{searchValue()}}"</td>
          </tr>
              </table>
      </div>      
      }@else if(currentTabName=='site'){
        <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort class="w-100 custom-premium-table">
          <!--
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> ID </th>
            <td mat-cell *matCellDef="let row"  data-label="ID"> {{row.assurance_id}} </td>
          </ng-container> -->
          <!-- -->

          <ng-container matColumnDef="site">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Bureaux </th>
            <td mat-cell *matCellDef="let row" class="fw-semibold text-dark"  data-label="Zone"> {{row.site}} </td>
          </ng-container>
          <!-- -->

          <ng-container matColumnDef="groupe">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Groupe </th>
            <td mat-cell *matCellDef="let row"  data-label="Zone"> {{row.groupe_name}} </td>
          </ng-container>
          <!-- -->


          <ng-container matColumnDef="production">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Nombre </th>
            <td mat-cell *matCellDef="let row"  data-label="Zone"> {{row.production}} </td>
          </ng-container>
          <!-- -->

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">No data matching the filter "{{searchValue()}}"</td>
          </tr>
              </table>
      </div>      }
      </div>
  </mat-card-content>

  <div class="border-top bg-white">
      <mat-paginator [pageSizeOptions]="[6, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
  </div>
</mat-card>

